import { createImageRenderer } from './imageRenderer.jsx'

// Tiles generated by mahjong-manage.com paiga tool (シンプル/flat variant),
// vendored as <code>.png under public/tiles/paiga. Tile art: 66x90.
export const paigaRenderer = createImageRenderer({
  basePath: '/tiles/paiga',
  fileFor: (code) => code,
  aspect: 90 / 66,
  ext: 'png',
})

export default paigaRenderer
